<!-- 登录页面 -->
<template>
    <div :style="'height:' + innerHeight + 'px;'">
        <div class="bg"></div>
        <div class="card">
            <div class="title">登录</div>
            <Form ref="formInline" :model="formInline" :rules="ruleInline">
                <FormItem prop="account">
                    <div class="mb-12 position_relative">
                        <Input class="width_100" type="text" v-model="formInline.account" placeholder="用户名"/>
                        <Icon class="form_icon" size="20" type="ios-person-outline"></Icon>
                    </div>
                </FormItem>
                <FormItem prop="pwd">
                    <div class="mb-12 position_relative">
                        <Input class="width_100" type="password" v-model="formInline.pwd" placeholder="账户密码"/>
                        <Icon class="form_icon" size="20" type="ios-lock-outline"></Icon>
                    </div>
                </FormItem>
                <FormItem>
                    <Button @click="handleSubmit('formInline')">点 击 登 录</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>
<script>
import { 
    login,
    tokens,
} from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { setCookies } from "@/utils/helper";
export default {
    data() {
        return {
            innerHeight: 0,
            formInline: {
                account: "",
                pwd: "",
            },
            ruleInline: {
                account: [
                    {
                        required: true,
                        message: "账户不能为空",
                        trigger: "blur",
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
        let hashPart = window.location.hash;
        let queryString = hashPart.replace(/^#\/\?/, "?");
        let params = new URLSearchParams(queryString);
        let tokenValue = params.get("token");
        console.log(tokenValue);
        if (tokenValue) {
            console.log("token登录");
            tokens({ token: tokenValue }).then((res) => {
                this.$Message.success(res.msg);
                setCookies("pcToken", res.data.token);
                localStorage.setItem("user", res.data.account);
                localStorage.setItem("phone", res.data.phone);
                localStorage.setItem("id", res.data.id);
                localStorage.setItem("admin_id", res.data.admin_id);
                this.$store.commit("setMenus", res.data.menu);
                localStorage.setItem("demo_file_path", res.data.demo_file_path);
                this.$router.push({ path: "/admin" });
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        }
    },
    created() {
        var _this = this;
        document.onkeydown = function () {
            if (_this.$route.name === "登录") {
                let key = window.event.keyCode;
                if (key === 13) {
                    _this.handleSubmit("formInline");
                }
            }
        };
    },
    methods: {
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    login(this.formInline).then((res) => {
                        this.$Message.success(res.msg);
                        setCookies("pcToken", res.data.token);
                        localStorage.setItem("user", res.data.account);
                        localStorage.setItem("phone", res.data.phone);
                        localStorage.setItem("id", res.data.id);
                        localStorage.setItem("admin_id", res.data.admin_id);
                        this.$store.commit("setMenus", res.data.menu);
                        localStorage.setItem("demo_file_path", res.data.demo_file_path);
                        this.$router.push({ path: "/admin" });
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                } else {
                    this.$Message.error("数据不能为空");
                }
            });
        },
    },
};
</script>
<style scoped>
.bg {
    background: url("../../assets/login_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.card {
    margin: 0 0 0 20vw;
    width: 350px;
    height: 100%;
    position: absolute;
    z-index: 999;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.title {
    margin: 0 0 24px 0;
    font-weight: 600;
    font-size: 30px;
    color: #ff761d;
}
::v-deep .ivu-input {
    padding: 0 0 0 33px;
    height: 46px;
    background: #ffffff;
    border-radius: 25px;
    border: 1px solid #999999;
    font-size: 16px;
    color: #999999;
}
::v-deep .ivu-btn {
    width: 100%;
    height: 46px;
    background: linear-gradient(90deg, #ff822e 0%, #ffa451 100%);
    border-radius: 25px;
    font-size: 18px;
    color: #ffffff;
}
.position_relative {
    position: relative;
}
.width_100 {
    width: 100%;
}
.form_icon {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    z-index: 999;
    top: 13px;
}
</style>